// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"783":"436c36bb","997":"0978cbbc"}[chunkId] + ".chunk.js";
};